const s = {
  name: "Ticket",
  dimensions: { width: 40, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 24" style="enable-background:new 0 0 40 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M29,10h-2v4h2V10z"/>
		<path class="st0" d="M27,20v-4h2v4H27z"/>
		<path class="st0" d="M27,4v4h2V4H27z"/>
		<path class="st0" d="M40,0H0v8h1c2.2,0,4,1.8,4,4c0,2.2-1.8,4-4,4H0v8h40v-8h-1c-2.2,0-4-1.8-4-4c0-2.2,1.8-4,4-4h1V0z M2,6.1V2
			h36v4.1C35.2,6.6,33,9,33,12c0,3,2.2,5.4,5,5.9V22H2v-4.1C4.8,17.4,7,15,7,12C7,9,4.8,6.6,2,6.1z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Ticket
};
